import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=65a9a88a&scoped=true"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=65a9a88a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a9a88a",
  null
  
)

export default component.exports